import { DataModel } from "common/models/utility-models/base-model"

export class ResetForgotPasswordModel extends DataModel {
    email : any = ""
    temppassword: any = ""
    newpassword: any = ""
    confirmpassword: any = ""
    
}